import axios from 'axios'
import router from "@/router"
import store from '@/store'
import { DialogType } from '@/enums/dialogType'

const api = axios.create({
    baseURL: 'https://maioliestoques.cloud/api',
})

// Interceptor de request
api.interceptors.request.use(config => {
    store.dispatch('startLoading')
    const token = localStorage.getItem("token")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Interceptor de resposta
api.interceptors.response.use(
    response => {
        store.dispatch('stopLoading')
        return response
    },
    async error => {
        if (error.response && error.response.status === 401) {
            // Remove token
            localStorage.removeItem("token")
            // Redireciona para login
            router.push({ name: "Login" })
        }

        let message = 'Erro inesperado'

        if (error.response?.data instanceof Blob) {
            // 👇 lê o conteúdo do Blob
            const text = await error.response.data.text()
            try {
                const json = JSON.parse(text)

                message =
                    json.detail ||  
                    json.title ||
                    json.message ||     
                    json.title ||       
                    text
            } catch {
                message = text
            }
        } else {
            message =
                error.response?.data?.detail ||
                error.response?.data?.title ||
                error.response?.data?.message ||
                error.response?.data ||
                error.message
        }

        store.dispatch('systemDialog/show', {
            type: DialogType.ERROR,
            message: message
        }, { root: true })
        
        store.dispatch('stopLoading')

        return Promise.reject(error)
    }
)

export default api
